import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-primary-100/50 pt-16 lg:pt-20">
      <div className="container-max section-padding text-center">
        <div className="max-w-2xl mx-auto">
        {/*  404动画图标 */}
          <div className="mb-8">
            <div className="relative inline-block">
              <div className="text-8xl sm:text-9xl font-black text-primary-200 select-none">
                404
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-20 h-20 bg-gradient-to-br from-primary-600 to-primary-700 rounded-xl flex items-center justify-center animate-bounce">
                  <i className="fas fa-robot text-3xl text-white"></i>
                </div>
              </div>
            </div>
          </div>

        {/*  错误信息 */}
          <h1 className="text-3xl sm:text-4xl font-bold text-primary-900 mb-4">
            页面走丢了
          </h1>
          <p className="text-lg text-primary-600 mb-8 leading-relaxed">
            抱歉，您访问的页面不存在或已被改动。
            <br />
            让我们的智能机器人带您回到正确的地方！
          </p>

        {/*  操作按钮 */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link to="/" className="btn-primary group">
              <i className="fas fa-home mr-2 group-hover:animate-bounce"></i>
              返回首页
            </Link>
            <Link to="/products" className="btn-secondary group">
              <i className="fas fa-robot mr-2 group-hover:animate-pulse"></i>
              查看产品
            </Link>
          </div>

        {/*  快速导航 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-primary-200">
            <h3 className="text-lg font-semibold text-primary-900 mb-4">
              快速导航
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              <Link
                to="/products"
                className="flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors p-2 rounded-lg hover:bg-primary-50"
              >
                <i className="fas fa-congs text-primary-500"></i>
                <span>产品中心</span>
              </Link>
              <Link
                to="/products"
                className="flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors p-2 rounded-lg hover:bg-primary-50"
              >
                <i className="fas fa-congs text-primary-500"></i>
                <span>产品中心</span>
              </Link>
              <Link
                to="/solutions"
                className="flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors p-2 rounded-lg hover:bg-primary-50"
              >
                <i className="fas fa-lightbulb text-primary-500"></i>
                <span>解决方案</span>
              </Link>
              <Link
                to="/about"
                className="flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors p-2 rounded-lg hover:bg-primary-50"
              >
                <i className="fas fa-building text-primary-500"></i>
                <span>关于我们</span>
              </Link>
              <Link
                to="/news"
                className="flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors p-2 rounded-lg hover:bg-primary-50"
              >
                <i className="fas fa-newspaper text-primary-500"></i>
                <span>新闻资讯</span>
              </Link>
              <Link
                to="/contact"
                className="flex items-center space-x-2 text-primary-600 hover:text-primary-700 transition-colors p-2 rounded-lg hover:bg-primary-50"
              >
                <i className="fas fa-phone text-primary-500"></i>
                <span>联系我们</span>
              </Link>
            </div>
          </div>

        {/*  装饰元素 */}
          <div className="absolute top-20 left-10 w-32 h-32 bg-blue-400/10 rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-24 h-24 bg-purple-400/10 rounded-full animate-pulse style={{animationDelay: '1s'}}"></div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
